export enum BannerType {
  Success = "Success",
  Warning = "Warning",
  Failure = "Failure",
  Info = "Info",
}
